import { Navigate } from 'react-router';
import useSetupAccountPageState from './Hook/useSetupAccountPageState';
import AccountCreationForm from '@/Components/AccountCreation/AccountCreationForm';
import SignupFlowLayout from '@/Components/layouts/SignupFlowLayout/SignupFlowLayout';
import { LoadingOverlay } from '@/Components/shared';
import { useUserContext } from '@/Context/UserContext';
import RoutePath from '@/Routing/RoutePath';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';
import UIStrings from '@/Utils/UIStrings';

const SetupAccountPage = () => {
    const { allowAccountSetup, isLoading, isSubmitting, submitHandler } = useSetupAccountPageState();
    const { user } = useUserContext();

    if (isLoading) {
        return <LoadingOverlay />;
    }

    return allowAccountSetup ? (
        <SignupFlowLayout currentStep="profile">
            <h1 className="text-foreground mb-3 text-[2rem] leading-[1.08] font-extrabold tracking-tight lg:text-[2.5rem]">
                {UIStrings.SetupYourProfile}
            </h1>
            <AccountCreationForm
                submitHandler={submitHandler}
                isSubmitting={isSubmitting}
                initialCompanyName=""
                initialFirstName={user.firstName || ''}
                initialLastName={user.lastName || ''}
            />
        </SignupFlowLayout>
    ) : (
        <Navigate to={RoutePath.Root} />
    );
};

export default withTalentMeshUserRequired(SetupAccountPage);
